import { RectangularWindow } from './RectangularWindow';
import { CircularWindow } from './CircularWindow';
import { UpperCircularWindow } from './UpperCircularWindow';
import { IsoscelesTriangleWindow } from './IsoscelesTriangleWindow';
import { ObliqueTopLeftWindow } from './ObliqueTopLeftWindow';
import { ObliqueTopRightWindow } from './ObliqueTopRightWindow';
import { PerpendicularTriangleBottomLeftWindow } from './PerpendicularTriangleBottomLeftWindow';
import { PerpendicularTriangleBottomRightWindow } from './PerpendicularTriangleBottomRightWindow';
import { PointyTopWindow } from './PointyTopWindow';
import * as util from '../util';
import { get, getOrNull } from './WindowHelpers';

function build(renderer, parent, def) {
  def = get(def, 'ModelPosition');
  var modificationType = getOrNull(def, 'Geometry', 'ModificationType');

  switch (modificationType) {
    case '1C':
      return new UpperCircularWindow(renderer, parent, def); // Half circle
    case '1B':
      return new CircularWindow(renderer, parent, def); // Circle
    case '4B':
      return new IsoscelesTriangleWindow(renderer, parent, def); // Isosceles triangle
    case '4A':
      return new PerpendicularTriangleBottomRightWindow(renderer, parent, def); // Triangle, bottom right perpendicular
    case '4C':
      return new PerpendicularTriangleBottomLeftWindow(renderer, parent, def); // Triangle, bottom left perpendicular
    case '2B':
      return new PointyTopWindow(renderer, parent, def); // 4-sided, pointy top right
    case '3A':
      return new ObliqueTopLeftWindow(renderer, parent, def); // 4-sided, pointy top left
    case '3B':
      return new ObliqueTopRightWindow(renderer, parent, def); // 4-sided, pointy top center
  }
  return new RectangularWindow(renderer, parent, def);
}

export function buildWindow(renderer, parent, def) {
  if (util.debug) {
    return build(renderer, parent, def);
  } else {
    try {
      return build(renderer, parent, def);
    } catch (ex) {
      if (ex.jsonDefError) {
        util.alert(ex.message);
      } else {
        util.alert('Internal error: ' + ex);
      }
      return null;
    }
  }
}
